import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {
    FETCH_INVOICES_DATA: createAsyncActionConstants('FETCH_INVOICES_DATA'),
    FETCH_ETS_INVOICES_DATA: createAsyncActionConstants('FETCH_ETS_INVOICES_DATA'),
    FETCH_INVOICE_HISTORY: createAsyncActionConstants('FETCH_INVOICE_HISTORY'),
    SEARCH_INVOICES: createAsyncActionConstants('SEARCH_INVOICES'),
    SEARCH_INVOICES_DESTINATION: createAsyncActionConstants('SEARCH_INVOICES_DESTINATION'),
    FETCH_INVOICE_DETAILS: createAsyncActionConstants('FETCH_INVOICE_DETAILS'),
    FETCH_ISSO_DETAILS: createAsyncActionConstants('FETCH_ISSO_DETAILS'),
    RESET_INVOICES: createAsyncActionConstants('RESET_INVOICES'),
    RESET_ETS_INVOICES: createAsyncActionConstants('RESET_ETS_INVOICES'),
    SUBMIT_INVOICES: createAsyncActionConstants('SUBMIT_INVOICES'),
    RESET_SUBMIT_INVOICES: createAsyncActionConstants('RESET_SUBMIT_INVOICES'),
    SET_SELECTED_INVOICES: createAsyncActionConstants('SET_SELECTED_INVOICES'),
    ADD_CREDIT_NOTES_INVOICES: createAsyncActionConstants('ADD_CREDIT_NOTES_INVOICES'),
    REPRINT_INVOICES: createAsyncActionConstants('REPRINT_INVOICES'),
    FETCH_FILE: createAsyncActionConstants('FETCH_FILE'),
    FETCH_PDF_FILE: createAsyncActionConstants('FETCH_PDF_FILE'),
    FETCH_CUSTOMER_INVOICES_DATA: createAsyncActionConstants('FETCH_CUSTOMER_INVOICES_DATA'),
    RESET_CUSTOMER_INVOICES: createAsyncActionConstants('RESET_CUSTOMER_INVOICES'),
    REPRINT_DRAFT_STATUS_VIEW_ORIGIN: createAsyncActionConstants('REPRINT_DRAFT_STATUS_VIEW_ORIGIN'),
    REPRINT_DRAFT_STATUS_VIEW_DESTINATION: createAsyncActionConstants('REPRINT_DRAFT_STATUS_VIEW_DESTINATION'),
}